import { LockKeyhole, Trophy } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardDescription, CardHeader, CardTitle, Grid, Text } from '@shared/ui';

const achievementExamples = [
  {
    id: 'first-dive',
    titleKey: 'uiLibrary.dataDisplay.achievements.items.firstDive.title',
    descriptionKey: 'uiLibrary.dataDisplay.achievements.items.firstDive.description',
    earned: true,
    date: '2024-01-02',
  },
  {
    id: 'certified-freediver',
    titleKey: 'uiLibrary.dataDisplay.achievements.items.certifiedFreediver.title',
    descriptionKey: 'uiLibrary.dataDisplay.achievements.items.certifiedFreediver.description',
    earned: true,
    date: '2024-01-15',
  },
  {
    id: 'deep-diver',
    titleKey: 'uiLibrary.dataDisplay.achievements.items.deepDiver.title',
    descriptionKey: 'uiLibrary.dataDisplay.achievements.items.deepDiver.description',
    earned: false,
    date: null,
  },
] as const;

export function AchievementsShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.achievements.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.achievements.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Grid cols={3} gap="md" className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {achievementExamples.map((achievement) => (
            <Card
              key={achievement.id}
              className={achievement.earned ? 'border-primary bg-primary/5' : 'opacity-60'}
            >
              <CardContent className="p-4">
                <div className="mb-3 flex items-start justify-between gap-4">
                  <div
                    className={
                      achievement.earned
                        ? 'flex size-10 items-center justify-center rounded-full bg-primary text-primary-foreground'
                        : 'flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground'
                    }
                  >
                    {achievement.earned ? (
                      <Trophy aria-hidden="true" className="size-5" />
                    ) : (
                      <LockKeyhole aria-hidden="true" className="size-5" />
                    )}
                  </div>
                  {achievement.date ? (
                    <Text size="sm" color="muted">
                      {achievement.date}
                    </Text>
                  ) : null}
                </div>
                <Text className="font-semibold text-card-foreground">
                  {t(achievement.titleKey)}
                </Text>
                <Text size="sm" color="muted" className="mt-1">
                  {t(achievement.descriptionKey)}
                </Text>
              </CardContent>
            </Card>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
